import { ShopCommonLayout } from "../../layouts/ShopCommonLayout";

const ShopHome = () => {
  return (
    <ShopCommonLayout>
      <>
        <div className="bg-[#FECB4B] h-[500px]">
          <div
            className="h-full py-[12px] flex justify-center items-center  /
    w-full"
          >
            <div className="relative  max-w-[1200px] text-[14px] mx-10 w-full h-full">
              <div className="absolute top-0 bottom-0 left-0 right-0 flex flex-row justify-between items-center">
                <div className="rounded-full bg-black opacity-[0.2] aspect-[1/1] w-[42px] flex justify-center items-center">
                  <img
                    className="w-[0.6837rem]"
                    alt="아래 화살표 아이콘"
                    src="/assets/icons/Arrow%20-%20Down%202.svg"
                  />
                </div>
                <div className=" rounded-full bg-black opacity-[0.2] aspect-[1/1] w-[42px] flex justify-center items-center">
                  <img
                    className="w-[0.6837rem]"
                    alt="아래 화살표 아이콘"
                    src="/assets/icons/Arrow%20-%20Down%202.svg"
                  />
                </div>
              </div>
              <div className="absolute left-0 right-0 bottom-[30px] flex flex-row gap-3 justify-center">
                <div className="w-[12px] h-[12px] bg-black opacity-[0.2] rounded-full"></div>
                <div className="w-[12px] h-[12px] bg-black  rounded-full"></div>
                <div className="w-[12px] h-[12px] bg-black opacity-[0.2] rounded-full"></div>
                <div className="w-[12px] h-[12px] bg-black opacity-[0.2] rounded-full"></div>              <div className="w-[12px] h-[12px] bg-black opacity-[0.2] rounded-full"></div>

              </div>
            </div>
          </div>
        </div>
      </>
    </ShopCommonLayout>

  );
};

export default ShopHome;
